<div class="content-wrapper table-full-bx">
    <div class="account-settings">
        <div class="row">
            <div class="col-lg-12">
                <div class="ibox ">  
                        <div class="ibox-body">
                                <div class="iboxcontent">
                                    <h3>Account Settings</h3>                                              
                                </div>
                                <!-- Account settings  -->
                                <div class="row">
                                    <div class="col-lg-3 col-sm-12">
                                          <!-- Tabs nav -->
                                        <div class="nav nav-pills nav-pills-custom pills-custom">
                                              <a class="nav-link mb-3 p-3 "  href="javascript:void(0);" routerLink="/account-settings/change-password">
                                                  <span  class=" ">Change password</span>
                                              </a>
                          
                                              <a class="nav-link mb-3 p-3  " href="javascript:void(0);" routerLink="/account-settings/notification" >
                                                 
                                                  <span class=" ">Notifications</span>
                                              </a>
                          
                                              <a class="nav-link mb-3 p-3 " href="javascript:void(0);" routerLink="/account-settings/save-card" hidden>
                                      
                                                  <span class=" ">Saved cards</span>
                                              </a>
                          
                                            
                          
                                              <a class="nav-link mb-3 p-3 " href="javascript:void(0);" routerLink="/account-settings/inventory-history" >
                                              
                                                  <span class="">Subscriptions</span>
                                              </a>
                                              <a class="nav-link mb-3 p-3 " href="javascript:void(0);" routerLink="/account-settings/billing-address" >
                                      
                                                <span class=" ">Billing address</span>
                                            </a>
                  
                                            <a class="nav-link mb-3 p-3 active " href="javascript:void(0);" routerLink="/account-settings/my-templates" >
                                      
                                              <span class=" ">My templates</span>
                                          </a>
                                           
                                            </div>
                                    </div>
                                             
                                      <div class="col-lg-9 col-sm-12">
                                          <!-- Tabs content -->
                                          <div class="tab-content" id="v-pills-tabContent">
                                              <div class="tab-pane fade  bg-box show active " >
                                                
                                             
                                                <div class="flexbox">
                                                    <div class="iboxcontent">
                                                        <h2 class="mainTitle">My Templates</h2>
                                                    </div>
                                                    <div class="input-group-icon input-group-icon-left">
                                                        <div class="col-list-right">
                                                            <a href="javascript:void(0)" (click)="open(edit)" class="commonBtn2" ><img src="assets/images/ic_add_project.svg" class="ap"> Add a new template</a>
                                                         </div>
                                                </div> 
                                                </div>
                                                <div class="table-scroll table-wrapper table-responsive">
                                                    <table id="example" class="table   table-bordered table-hover m-0" style="width:100%">
                                                        <thead>
                                                            <tr>
                                                                <th class="sorting_asc">Subject </th>
                                                                <th class="sorting_asc"> Description </th>
                                                                <th class="sorting_asc"> Date Modified</th>
                                                                <th class="sorting_asc"> Status</th>
                                                                <th class="sorting_disabled" data-orderable="false"> Action</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr *ngFor="let data of allData; let i=index;">
                                                                <td><a href="javascript:void(0)">{{data.subject}}</a></td>
                                                                <td><a href="javascript:void(0)">{{data.description}}</a></td>
                                                                <td><a href="javascript:void(0)">{{data.updatedAt | date: "d/M/YYYY h:mm a"}}</a></td>
                                                                <td><a href="javascript:void(0)"> <span *ngIf="data?.action == 0">Hired</span>
                                                                    <span *ngIf="data?.action == 2">Rejected</span>
                                                                    <span *ngIf="data?.action == 1">Short listed</span>
                                                                    <span *ngIf="data?.action == 3">On Hold</span>
                                                                    <span *ngIf="data?.action == 4">BV not cleared</span>
                                                                    <span *ngIf="data?.action == 5">Hired</span></a></td>
                                                                <td>
                                                                    <div ngbDropdown>
                                                                        <a class="icon dropdown-toggle dropdownlist" href="javascript:void(0);" data-toggle="dropdown" role="button" aria-haspopup="true"
                                                                        aria-expanded="false" id="dropdown_profile_area" ngbDropdownToggle><img src ="assets/images/ic_three_dot.svg"></a>
                                                                        <ul class="dropdown-menu dropdown-menu-left dropdown-menu-animated dropdown-arrow "
                                                                        ngbDropdownMenu>
                                                                             <li><a class="dropdown-item" href="javascript:void(0);" (click)="view(data,preview)">Preview</a></li>
                                                                            <li><a class="dropdown-item" href="javascript:void(0);" (click)="openModal(data,edit)">Edit</a></li>
                                                                            <li><a class="dropdown-item" href="javascript:void(0);" (click)="deleteStatus(data.id)">Delete</a></li>
                                                                        </ul>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                        
                                                    </table>
                                                    
                                                    <div class="noDataFound" *ngIf="allData.length == 0">
                                                        <h2>No Records Found</h2>
                                                    </div>
                                                </div>    
                                                <div class="col-sm-12 p-0" *ngIf="allData.length > 9">
                                                    <ul class="pagination">
                                                        <pagination-controls id="pagination" (pageChange)="pageChanged($event)" previousText="&#60;" nextText="Next" firstText="&#62;" lastText="Last"></pagination-controls> 
                                                    </ul>
                                                </div>
                                            </div>
                                              </div>
                                                
                                      </div>
                                         
                                      </div>
                                <!-- End -->
                        </div>
                </div>
            </div>
        </div>                    
    </div>
</div>    



<ng-template #preview> 
    <div class="modal-body addModal text-left"> 
        <h4 class="pageTitle upper"><span>Edit Email Template Detail <img src="../../../assets/images/ic_edit.svg" class="ht" alt="edit" (click)="modalRef?.hide();openModal(temId,edit)"> </span>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close"
        (click)="modalRef?.hide()">&times;</button></h4>
        <div class="preview">
          <div class="row">
            <div class="col-lg-4">
                <div class="form-group">
                    <label>Subject :</label><br>
                    <strong>{{temId?.subject || "N/A"}}</strong>
                </div>
            </div>
            <div class="col-lg-4">
                <div class="form-group">
                    <label>Action :</label><br>
                    <strong *ngIf="temId?.action == 1">Shortlisted</strong>
                    <strong *ngIf="temId?.action == 2">Rejected</strong>
                    <strong *ngIf="temId?.action == 3">Hold</strong>
                    <strong *ngIf="temId?.action == 4">BV not cleared</strong>
                    <strong *ngIf="temId?.action == 5">Hired</strong> 
                </div>
            </div>
            <div class="col-lg-4">
                <div class="form-group">
                    <label>Date :</label><br>
                    <strong>{{temId?.updatedAt | date: "d/M/YYYY h:mm a"}}</strong>
                </div>
            </div>
          </div>
          <div class="form-group">
            <p class="text-left m-0">{{temId?.description || "N/A"}}</p>
          </div> 
          <div class="form-group" hidden>
            <p class="text-left m-0">Thanks & Regards,</p>
            <p class="text-left m-0">Elon Smith <br> Head Recruiting<br> XYZ Pvt. Ltd.</p>
          </div> 
        </div>
  </div>
  </ng-template> 

<ng-template #edit>
    <div class="modal-body addModal text-left"> 
        <form [formGroup]="form" (ngSubmit)="onSubmit()">
            <h4 class="pageTitle upper">{{title}} a New Email Template</h4>
          <div class="form-group">
            <div class="d-flex">
                <label>Subject:</label>
                <input type="text" class="form-control" placeholder="Enter" formControlName="subject" maxlength="50">
            </div>
            <div class="text-danger" *ngIf="form.controls['subject'].hasError('required') && showError">
                *Please Enter Subject.
            </div>
          </div>
          <div class="form-group">
            <div class="d-flex">
                <label>Action:</label>
                <select class="form-control" formControlName="action">
                    <option selected disabled>Please select</option>
                    <!-- <option value="0">Hired</option> -->
                    <option value="1">Shortlisted</option>
                    <option value="2">Rejected</option>
                    <option value="3">On Hold</option>
                    <option value="4">BV not cleared</option>
                    <option value="5">Hired</option>
                </select>
            </div>
            <div class="text-danger" *ngIf="form.controls['action'].hasError('required') && showError">
                *Please Enter action.
            </div>
          </div>
          <div class="form-group">
            <textarea class="form-control pdding-10" placeholder="Please write here" formControlName="description" maxlength="2000"></textarea>
            <div class="text-danger" *ngIf="form.controls['description'].hasError('required') && showError">
                *Please Enter description.
            </div>
          </div>
          <div class="text-right">
          <div class="form-group text-right">
            <a href="javascript:void(0);" class="planbtn greyBtn" (click)="modalRef?.hide()">Cancel</a> 
            <input type="submit" value="Save"  class="planbtn fill" *ngIf="title == 'Edit'">
            <input type="submit" value="Send"  class="planbtn fill" *ngIf="title == 'Add'">
          </div>
          
        </div>
            
          <div class="instruction">
            <h5><img src="../../../../assets/images/info-circle.svg" alt="info-circle"> The following place holders are allowed:</h5>
            <ul>
                <li>
                    •  &#10100;&#10100;USERNAME&#10101;&#10101; - Username for whom the mail will be sent 
                </li>
                <li>
                    • &#10100;&#10100;USERFULLNAME&#10101;&#10101; - Sender’s full name 
                </li>
                <li>
                    • &#10100;&#10100;MYEMAIL&#10101;&#10101; - Sender’s email address 
                </li>
                <li>
                    • &#10100;&#10100;EMAIL&#10101;&#10101; - Recipient’s email address 
                </li>
                <li>
                    • &#10100;&#10100;ORGANIZATIONNAME&#10101;&#10101; - Organization Name for which the Action is performed 
                </li>
            </ul>
          </div>
        <div class="form-group"> 
            
          </div>
        </form>
  </div>
  </ng-template> 